import get from 'lodash/get.js';

class Interceptor {
    constructor(store, router) {
        this.$store = store;
        this.$router = router;
    }

    processor() {
        return {
            response: response => response,
            error: error => {
                this.handle(get(error, 'response.status'), error);

                return Promise.reject(error);
            },
        };
    }
}

export default Interceptor;
